import './job-bookmark-btn.scss';

class JobBookmarkBtn {
    constructor ($element) {
        this.$jobBookmarkBtn = $element;
        this.$jobBookmarkLabel = this.$jobBookmarkBtn.querySelector('[data-job-bookmark-label]');
        this.activeState = false;
        this.jobId = this.$jobBookmarkBtn.dataset.jobBookmarkId;

        if (localStorage.getItem('bookmarkedJobs') !== undefined) {
            this.initialize();
        } else {
            localStorage.setItem('bookmarkedJobs', JSON.stringify([]));
            this.initialize();
        }
    }

    initialize () {
        this.checkJobBookmark(this.jobId);

        this.$jobBookmarkBtn.onclick = () => {
            if (this.activeState === false) {
                this.activeState = true;
                this.addJobBookmark(this.jobId);
                this.$jobBookmarkBtn.dataset.jobBookmarked = 'true';
                this.$jobBookmarkLabel.innerText = this.$jobBookmarkBtn.dataset.jobUnbookedLabel;
            } else {
                this.activeState = false;
                this.removeJobBookmark(this.jobId);
                this.$jobBookmarkBtn.dataset.jobBookmarked = 'false';
                this.$jobBookmarkLabel.innerText = this.$jobBookmarkBtn.dataset.jobBookingLabel;
            }

            // this updates the bookmark link and amount in the navigation - look into the app.js
            // this fires also a reload on the "booked" page type - look into job-bookmark.js
            const bookmarkUpdateEvent = new CustomEvent('update.bookmarks', {
                view: window,
                bubbles: true,
                cancelable: false,
                detail: {
                    $context: document
                }
            });
            window.dispatchEvent(bookmarkUpdateEvent);
        };
    }

    addJobBookmark (jobId) {
        let bookmarkedJobs = JSON.parse(localStorage.getItem('bookmarkedJobs')) || [];
        const jobAlreadyBookmarked = bookmarkedJobs.some(job => job.id === jobId);

        if (!jobAlreadyBookmarked) {
            bookmarkedJobs.push({ id: jobId }); // add job id to array
            localStorage.setItem('bookmarkedJobs', JSON.stringify(bookmarkedJobs));
        }
    }

    removeJobBookmark (jobId) {
        let bookmarkedJobs = JSON.parse(localStorage.getItem('bookmarkedJobs')) || [];
        const updatedJobs = bookmarkedJobs.filter(job => job.id !== jobId); // remove job by id from array
        localStorage.setItem('bookmarkedJobs', JSON.stringify(updatedJobs));
    }

    // init call to set all states correct
    checkJobBookmark (jobId) {
        let bookmarkedJobs = JSON.parse(localStorage.getItem('bookmarkedJobs')) || [];
        const jobAlreadyBookmarked = bookmarkedJobs.some(job => job.id === jobId);

        if (jobAlreadyBookmarked) {
            this.activeState = true;
            this.$jobBookmarkBtn.dataset.jobBookmarked = 'true';
            this.$jobBookmarkLabel.innerText = this.$jobBookmarkBtn.dataset.jobUnbookedLabel;
        }
    }
}

export { JobBookmarkBtn };

window.addEventListener('content.loaded', (e) => {
    const eventDetails = e.detail;
    const $context = eventDetails.$context;

    const $$jobBookmarkBtn = $context.querySelectorAll('[data-job-bookmark-btn="root"]');

    if ($$jobBookmarkBtn.length > 0) {
        $$jobBookmarkBtn.forEach(($jobBookmarkBtn) => {
            const jobBookmarkBtn = new JobBookmarkBtn($jobBookmarkBtn); // eslint-disable-line
        });
    }
});